import React from 'react';
import { Gavel } from 'lucide-react';

/**
 * Moderator badge — distinct from Admin shield and Premium star.
 * Lavender accent with a gavel icon to indicate moderation duties.
 */
const ModeratorBadge = React.forwardRef(({ show, withLabel = true, size = 12, light = false, className = '', ...rest }, ref) => {
  if (!show) return null;
  return (
    <span
      ref={ref}
      aria-label="Sirati Moderator"
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full font-semibold ${light ? 'bg-white/15 text-white text-xs' : 'bg-secondary/20 text-secondary text-[10px]'} ${className}`}
      style={light ? undefined : { background: 'rgba(169,156,200,0.18)', color: '#7d6dab' }}
      data-testid="moderator-badge"
      {...rest}
    >
      <Gavel aria-hidden="true" style={{ width: size, height: size }} />
      {withLabel && <span>Mod</span>}
    </span>
  );
});
ModeratorBadge.displayName = 'ModeratorBadge';

export default ModeratorBadge;
